import type { InviteToken } from '~/evaluator/domain/invite-token';
import * as tokenExchangeApi from '~/evaluator/service/token-exchange.api';

export async function validateToken({
  token,
  dialect,
}: ValidateToken): Promise<ValidatedToken> {
  const inviteToken = await tokenExchangeApi.validateToken(token, dialect);

  return { ...inviteToken, token, dialect };
}

export type ValidateToken = {
  token: string;
  dialect?: string;
};

export type ValidatedToken = InviteToken & {
  token: string;
  dialect?: string;
};
